export class OTA_Email {
    public emailType: number;
    public address: string;
    public operation: string;
    public shareMarketInd: string = "No";
}
